// extracted by mini-css-extract-plugin
export var attachmentContainer = "_nf-0";
export var fileList = "_nf-2";
export var removeFileButton = "_nf-1";